import React from "react";
import { Path } from "react-router-dom";
import { css } from "@emotion/react";

import { NOOP } from "core/constants";
import LinkTo from "core/Components/LinkTo";

type Props = {
    to?: string | Partial<Path>,
    children: React.ReactNode,
    margin?: string,
    onClick?: () => void,
    className?: string,
};

const Button: React.FC<Props> = ({
    to = null,
    children,
    margin,
    onClick = NOOP,
    className = "",
}) => {
    const style = css`
        display: flex;
        justify-content: center;
        
        ${margin && css`
            margin: ${margin}px;
        `};
    `;

    return (
        <LinkTo to={to} isDisabled={!to} className={className}>
            <div css={style} onClick={onClick}>
                {children}
            </div>
        </LinkTo>
    );
};

export default Button;
